<template>
  <v-dialog
    persistent
    v-model="dialog"
    scrollable
    @keydown.esc="dialog = false"
    width="850"
  >
    <LuAgencyDivisionForm
      :agency="agency"
      ref="luAgencyDivisionForm"
      :dialog.sync="dialog"
      @refresh="$emit('refresh')"
      @itemAdded="$emit('itemAdded', $event)"
    >
    </LuAgencyDivisionForm>
  </v-dialog>
</template>
<script>
import LuAgencyDivisionForm from '@components/form/add-edit/LuAgencyDivisionForm'
export default {
  components: {
    LuAgencyDivisionForm,
  },
  props: {
    agency: Number,
  },
  data: () => ({
    dialog: false,
  }),
  created() {},
  computed: {},
  methods: {
    editLuAgencyDivision(entry) {
      this.dialog = true
      this.$nextTick(() => {
        this.$refs.luAgencyDivisionForm.editLuAgencyDivision(entry)
      })
    },
    addLuAgencyDivision() {
      this.dialog = true
      this.$nextTick(() => {
        this.$refs.luAgencyDivisionForm.addLuAgencyDivision()
      })
    },
  },
}
</script>
<style></style>
